import { Env } from '../app/dto/enum/env.enum';
import { IConfigDTO } from '../app/dto/config/config.dto';
import { profileDTOs } from './profiles';
import { version } from '../../package.json';
import { availableLocales, defaultLocale } from '../../locales.json';
import { host } from '../../sitemap.json';

export const configDTO: IConfigDTO = {
  env: Env.PROD,
  api: 'https://api.ig4u.co',
  host: host,
  appVersion: version,
  retryCount: 5,
  recaptchaSiteKey: '6LdK6u4pAAAAAIzquc2-LyOdN7m3OJOdQHH6z-Ie',
  googleTagId: 'G-2R0CX2ZKES',
  defaultLocale: defaultLocale,
  availableLocales: availableLocales,
  sentry: {
    dsn: 'https://f620a7f21000366b7502fafc4f4f5f4f@o4507266554003456.ingest.de.sentry.io/4507270776225872',
    debug: false,
    replaysMaskAllText: true,
    replaysMaskAllInputs: true,
    replaysBlockAllMedia: true,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.0,
    tracesSampleRate: 0.25,
    tracePropagationTargets: [
      /^https:\/\/ig4u\.co/,
      /^https:\/\/api\.ig4u\.co/,
    ],
  },
  examples: {
    profiles: profileDTOs,
  },
  emojicom: {
    timeout: 15000,
    campaigns: [
      {
        locale: 'en',
        value: 'QLUi3ZW3VIiKyWT805om',
      },
      {
        locale: 'es',
        value: 'kZlLhrzWSrzchVVl7wzb',
      },
      {
        locale: 'pt',
        value: 'AI5Ff8AeimzA3YwpfGIP',
      },
      {
        locale: 'fr',
        value: 'bBGOhnbzwBz1nBsCTFT1',
      },
      {
        locale: 'de',
        value: 'i1wxm4tmZuj1p08H45m7',
      },
      {
        locale: 'it',
        value: 'uYjISo0VTEqjrNaftyAA',
      },
      {
        locale: 'tr',
        value: 'DAlJYhRfLXn5T8f8nz7q',
      },
      {
        locale: 'ru',
        value: '5M4qY6J2BXMEY5i9suCb',
      },
      {
        locale: 'pl',
        value: '7aGqyUWCPtIiZQrYQj4T',
      },
    ],
  },
};
